import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { adminSideLinks } from '../adminRoutes';

function AdminVerificationsPage() {
  return (
    <DashboardShell role="ADMIN" sideLinks={adminSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-navy">Verifications</h1>
        <p className="mt-2 text-sm text-slate-600">Review pending verifications and identity checks.</p>
      </div>
    </DashboardShell>
  );
}

export default AdminVerificationsPage;
